<template>
  <section class="admin-sessions-content">
    <GridBlockBase id="sessions-listing">
      <template #icon>
        <emailIcon color="black" filled />
      </template>
      <template #body>
        <CyclesList :cycles="cyclesRef" :isPending="isPendingCyclesRef" order="desc" />
      </template>
      <template #headerExtra>
        <CustomButton
          class="sessions-content__export-button"
          color="primary"
          data-test-id="create-reminder-button"
          :text="t('admin.reminders.addReminder')"
          usage="button"
          @emit:click="openAddReminderModal"
        />
      </template>
      <template #footer>
        <div>
          <span v-if="isPendingCyclesRef" class="table-sub-info">{{ t('ui.message.loading') }}</span>
          <span v-else class="table-sub-info">
            {{
              t('ui.pagination.resultsOfOn', {
                start: Math.min(Math.max(1, perPageRef * (pageRef - 1) + 1), totalCyclesRef ?? 1),
                end: Math.min(perPageRef * pageRef, totalCyclesRef ?? 1),
                total: totalCyclesRef,
              })
            }}
          </span>
        </div>
        <div class="page-select-wrapper">
          <CustomSelect
            placement="top"
            id="page-select"
            :value="`${pageRef}`"
            :options="pagesOptionsRef"
            :label="t('ui.pagination.page')"
            hide-label
            @emit:change="onPageChange"
          />
          <span v-if="isPendingCyclesRef" class="table-sub-info"> {{ t('ui.message.loading') }} </span>
          <span v-else class="table-sub-info">
            {{ t('ui.pagination.totalPages', { total: totalCyclesPagesRef }) }}
          </span>
        </div>
      </template>
    </GridBlockBase>
  </section>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import CyclesList from '@/features/admin/reminders/components/cycles-list/cycles-list.vue'
import useCycles from '@/features/admin/reminders/hooks/use-cycles.hook'
import CustomButton from '@/features/ui/components/button/custom-button.vue'
import GridBlockBase from '@/features/ui/components/grid-block-base/grid-block-base.vue'
import emailIcon from '@/features/ui/components/icons/email-icon.vue'
import CustomSelect from '@/features/ui/components/select/custom-select.vue'
import modalsStore from '@/features/ui/store/modal/modal.store'
import { useI18n } from '@/lib/i18n'

const { t } = useI18n()

const pageRef = ref<number>(1)
const perPageRef = ref<number>(20)

const { cyclesRef, totalCyclesPagesRef, totalCyclesRef, isPendingCyclesRef } = useCycles({
  pageRef,
  perPageRef,
})

function onPageChange(value: number) {
  pageRef.value = value
}

function openAddReminderModal() {
  modalsStore.updateModalAttachedData('admin-reminder-structure', { reminderId: null })
  modalsStore.toggleModal('admin-reminder-structure', true)
}

const pagesOptionsRef = computed(() => {
  return Array.from({ length: totalCyclesPagesRef.value ?? 0 }, (_, i) => ({
    label: `${t('ui.pagination.page')} ${i + 1}`,
    value: `${i + 1}`,
  })) satisfies { label: string; value: string }[]
})
</script>

<style lang="scss"></style>
